import {
  VStack, Text, Card, CardBody, CircularProgress, CircularProgressLabel,
} from "@chakra-ui/react";

interface StatCardProps {
  value: number;
  label: string;
  sublabel: string;
  color: string;
}

export default function StatCard({ value, label, sublabel, color }: StatCardProps) {
  return (
    <Card bg="white" borderWidth="1px" borderColor="tableBorder.500">
      <CardBody py={3}>
        <VStack spacing={1}>
          <CircularProgress
            value={value}
            color={color}
            size="56px"
            thickness="8px"
          >
            <CircularProgressLabel fontSize="sm" fontWeight="semibold" color="content.primary">
              {Math.round(value)}
              %
            </CircularProgressLabel>
          </CircularProgress>
          <Text fontSize="sm" fontWeight="medium" color="content.tertiary" textAlign="center">
            {label}
          </Text>
          <Text fontSize="xs" color="content.tertiary">
            {sublabel}
          </Text>
        </VStack>
      </CardBody>
    </Card>
  );
}
